import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CapabilityEngineService } from '../capabilityEngine.service';
import { RedirectService } from '../redirect/redirect.service';
import { NewUserService } from './new-user.service';
import * as _ from 'lodash';



@Component({
    selector: 'app-new-user',
    templateUrl: './new-user.component.html',
    styleUrls: ['./new-user.component.scss']
})
export class NewUserComponent implements OnInit {

    user = {};
    myForm: FormGroup;
    errMessage: string = '';
    role: string = '';
    roleError: Boolean;
    publishedFormsCounts: Number = 0;
    assets:any = {};
    selectedAssets = {};
    assetsDropdownSettings = {
        singleSelection: false,
        text: "Select Assets",
        selectAllText: 'Select All',
        unSelectAllText: 'Deselect All',
        enableSearchFilter: true,
        classes: "myclass custom-class",
        labelKey: "name",
        maxHeight: 200,
        enableFilterSelectAll: false
    };
    assetSelectedItems:any = [];
    isCountryChanged: boolean = false;
    countryCode: string = '';
    
    constructor(
        private _newUserService: NewUserService,
        private _formBuilder: FormBuilder,
        private _router: Router,
        private _activatedRoute: ActivatedRoute,
        private _redirectService: RedirectService,
        private _capabilityEngineService: CapabilityEngineService
    ) { }
    ngOnInit() {
        let phoneInput = document.querySelector(`#user-phone`);
        // init plugin
        let win: any = window;
        let iti = win.intlTelInput(phoneInput, {
            utilsScript: '../../build/js/utils.js?1537727621611' // just for formatting/placeholders etc
        });

        let thisInstance = this;
        // // listen to the telephone input for changes
        phoneInput.addEventListener('countrychange', function (e) {
            thisInstance.countryCode = iti.getSelectedCountryData().dialCode;
            thisInstance.isCountryChanged = true;
        });

        const pathData = this._activatedRoute.data['_value'];
        if (this.canPerform(pathData.capabilities)) {
            this.myForm = this._formBuilder.group({
                name: ['', [Validators.required, Validators.pattern(/.*[^ ].*/)]],
                email: ['', [Validators.required, Validators.email]],
                // role: ['', Validators.required],
                phone: ['', [Validators.maxLength(15), Validators.pattern(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im)]],
                password: ['', [Validators.minLength(8)]]
            });
        }
        this._newUserService.publishedFormsCount().subscribe(
            (result: any) => {
                this.publishedFormsCounts = result.data.count;
            }
        );
        this._newUserService.assetsList().subscribe(
            (result: any) => {
                this.assets = result.data;
                _.forEach(Object.keys(this.assets), (assetKey) => {

                    this.assets[assetKey] = _.map(this.assets[assetKey], (asset) => { asset.id = asset._id; return asset; })
                })
            }
        );
    }

    canPerform(data) {
        return this._capabilityEngineService.canPerform(data);
    }

    newUser() {
        this.roleError = false;
        if (!this.role || this.role === '') {
            this.roleError = true;
            return;
        }
        if (this.myForm.valid) {
            let newUser = this.myForm.value;
            if(!_.isEmpty(newUser.phone)) {
                newUser.phone = '+' + this.countryCode + newUser.phone.toString()
            }
            newUser.role = this.role;
            if (this.selectedAssets && Object.keys(this.selectedAssets).length > 0) {
                newUser.assets = this.selectedAssets;
            }
            this._newUserService.newUser(newUser)
                .subscribe((data) => {
                    this._router.navigateByUrl('/usersList');
                }, (err) => {
                    this.errMessage = err.error.message;
                });
        } else {
            this.validateAllFormFields(this.myForm);
        }


    }

    removeErrorMessage() {
        this.errMessage = '';
    }

    isFieldValid(field: string) {
        return !this.myForm.get(field).valid && this.myForm.get(field).touched;
    }

    displayFieldCss(field: string) {
        return {
            'has-error': this.isFieldValid(field)
        };
    }

    validateAllFormFields(formGroup: FormGroup) {
        Object.keys(formGroup.controls).forEach(field => {
            console.log(field);
            const control = formGroup.get(field);
            if (control instanceof FormControl) {
                control.markAsTouched({ onlySelf: true });
            } else if (control instanceof FormGroup) {
                this.validateAllFormFields(control);
            }
        });
    }

    onSelectAll(event) {
        this.selectedAssets = {};
        _.forEach(this.assets['main'], (asset) => {
            var subAssets = [];
            _.forEach(this.assets[asset._id], (subAsset) => {
                subAssets.push(subAsset._id);
            })
            this.selectedAssets[asset._id] = subAssets;
        })
    }
    onDeSelectAll(event) {
        this.selectedAssets = {};
    }
    onItemSelect(event) {
        if (this.selectedAssets[event.assetId]) {
            if (this.selectedAssets[event.assetId].includes(event._id)) {
                const index = this.selectedAssets[event.assetId].indexOf(event._id);
                if (index > -1) {
                    (this.selectedAssets[event.assetId]).splice(index, 1);
                }

            } else {
                var assets = this.selectedAssets[event.assetId];
                assets.push(event._id);
                this.selectedAssets[event.assetId] = assets;
            }
        } else {
            this.selectedAssets[event.assetId] = [event._id];
        }
    }

    OnItemDeSelect(event) {
        if (this.selectedAssets[event.assetId]) {
            if (this.selectedAssets[event.assetId].includes(event._id)) {
                const index = this.selectedAssets[event.assetId].indexOf(event._id);
                if (index > -1) {
                    (this.selectedAssets[event.assetId]).splice(index, 1);
                }

            } else {
                var assets = this.selectedAssets[event.assetId];
                assets.push(event._id);
                this.selectedAssets[event.assetId] = assets;
            }
        } else {
            this.selectedAssets[event.assetId] = [event._id];
        }
    }

    isFormhound(){
       return this._capabilityEngineService.isFormhound();
    }

    isOshaMshaForm(){
        return this._capabilityEngineService.isOshaMshaForm();
    }

}



// WEBPACK FOOTER //
// ./src/app/new-user/new-user.component.ts